export const GET_OVERVIEW_FILTERS_SUCCESS = '[OVERVIEW][FILTERS] get overview filters';
export const GET_OVERVIEW_CASES_SUCCESS = '[OVERVIEW][GET] get Cases success';
export const SET_OVERVIEW_CASES_PARAMS_SUCCESS = '[OVERVIEW][SET] set Overview params success';
export const SET_OVERVIEW_POPULATE_PAYLOAD_SUCCESS = '[OVERVIEW] set Populate Payload success';

//Overview Case Filter
export const CLEAR_FILTER = 'clear overview filter';
export const ON_CHANGE = 'on overview change';

export const SET_POPULATE_PAYLOAD_SUCCESS = '[OVERVIEW] set Populate Payload success';


export const GET_OVERVIEW_CASES_PENDING = '[OVERVIEW][GET] get Cases pending';
export const GET_OVERVIEW_NEW_CASES_SUCCESS = '[OVERVIEW][GET] get New Cases success';

export const GET_OVERVIEW_CASE_REPRESENTATIVE_LIST_SUCCESS = '[OVERVIEW][GET] get Case Representative List success';
export const GET_OVERVIEW_CASE_ADDITIONAL_INFO_SUCCESS ='[OVERVIEW][GET] get Case Additional Info success';
// modal
export const SHOW_FILTER_MODAL = '[OVERVIEW][FILTERS] toggle Modal';
export const HYDRATE_CASES = '[OVERVIEW][DOCUMENTS] hydrate case documents';
export const HYDRATE_CASES_FILTERS = '[OVERVIEW][FILTERS] hydrate filters';
export const APPLY_CASES_FILTERS = '[OVERVIEW][FILTERS] apply filters';
export const APPLY_CASES_FILTERS_SUCCESS = '[OVERVIEW][FILTERS] apply filters success';
export const APPLY_CASES_FILTERS_FAILURE = '[OVERVIEW][FILTERS] apply filters failure';
export const GO_TO_DETAILS = '[OVERVIEW][LINK] redirect to case details';
export const GET_OVERVIEW_OPEN_CASES_SUCCESS = '[OVERVIEW][OPEN] get Open Cases success';
export const GET_OVERVIEW_DOCUMENTS_SUCCESS = '[OVERVIEW] Documents success';
// Overview case details

export const RESET_OVERVIEW_ID ='[OVERVIEW][DETAILS] reset overview id';
export const STORE_OVERVIEW_ID ='[OVERVIEW][DETAILS] store overview id';

export const STORE_CASE_DETAILS ='[OVERVIEW][DETAILS] store case details';  